<template>
  <div class="full-screen" id="login-content">
    <div class="wrap">
      <div class="text">
        <img alt="" src="../../../assets/login/ic_login_img.png"
             style="position: absolute;top: 45%;left: 10%;width:600px;height: 412px; ">
        <div class="bg-container">
          <div class="font-title-style">老刀码</div>
          <div style="font-size: 80px;font-weight: 700;color: white; letter-spacing: 2px;white-space: nowrap">超级产品说明书
          </div>
          <!--<div class="logoimg"></div>-->
        </div>
      </div>
      <!--轮播end-->
      <div class="login-main" style="border-radius: 8px;">
        <img @click="onScanClick" alt="" src="../../../assets/common/ic_login_qrcode.png"
             style="width: 58px;height: 58px;position: absolute;right: 0;top: 0;z-index: 1001;cursor: pointer"
             v-if="tabIndex === 0">
        <img @click="onScanCancelClick" alt="" src="../../../assets/common/ic_login_count.png"
             style="width: 58px;height: 58px;position: absolute;right: 0;top: 0;z-index: 1001;cursor: pointer"
             v-if="tabIndex === 2">
        <div class="login-warp">
          <!--<ul class="login-head" v-if="!choosecompany">-->
          <!--<li :class="{active:tabIndex === index}" :key="index" @click.self="tabIndex = index"-->
          <!--v-for="(head,index) in headLogins">{{head.belogin}}-->
          <!--</li>-->
          <!--</ul>-->
          <div class="h-40 flex a-center j-center bold fs-18 m-v-20">
            <div class="m-t-15">欢迎登录 {{apptitle}}</div>
          </div>

          <Form :label-width="40" :model="login" ref="login" style="margin-top: 20px; margin-bottom: 20px;width:100%"
                v-if="!choosecompany">
            <div style="height:250px" v-show="tabIndex === 0">
              <template v-if='state==="login"'>
                <FormItem prop="name" style="width: 300px;">

                  <!--                  <Input :key="11" :maxlength="13" placeholder="企业名称" v-model="accountName" class="m-b-20"/>-->
                  <Input :key="12" :maxlength="13" class="m-t-20" placeholder="手机号码" v-model="accountName"/>
                </FormItem>
                <FormItem prop="password" style="width: 300px">
                  <Input :key="13" placeholder="输入验证码" v-model="login.password">
                    <Button :disabled="timeout>0" @click="getLoginTelCodes" slot="append">
                      {{timeout===0?'获取验证码':`${timeout}后重试`}}
                    </Button>
                  </Input>
                </FormItem>
                <FormItem style="width: 300px">
                  <!--<Checkbox v-model="checked">记住账号</Checkbox>-->
                  <!--<a @click='state = "forget"' style="float:right;">忘记密码？</a>-->
                </FormItem>
                <FormItem style="width: 300px">
                  <div class="flex-row">
                    <Button @click="gotoReg"
                            style="width: 100%;margin-right: 10px;background-color:#E6F1FC;color:#2D8CF0 "
                            type="primary"
                            v-if="entId<1">注册
                    </Button>
                    <!--<Button @click="submitForm" style="width: 100%;margin-left: 10px" type="primary">短信码登录</Button>-->
                    <Button @click="submitSmsForm" style="width: 100%;margin-left: 10px" type="primary">短信码登录</Button>
                  </div>
                </FormItem>
                <FormItem style="width: 300px">
                  <div class="m-t-30">
                    <a @click='onContentMy' style="float:right;color: #4B8AFF">联系我们 >> </a>
                  </div>
                </FormItem>
                <FormItem style="width: 300px">
                  <!--                  <Button @click="gotojoincom"-->
                  <!--                          style="width: 100%;margin-right: 10px;background-color:#E6F1FC;color:#2D8CF0 "-->
                  <!--                          type="primary">加入企业-->
                  <!--</Button>-->
                </FormItem>
              </template>
              <template v-else-if='state === "forget"'>
                <FormItem prop="name" style="width: 300px">
                  <Input :key="12" :maxlength="13" placeholder="已认证手机" v-model="forgetphone"/>
                </FormItem>
                <FormItem style="width: 300px">
                  <Input :key="13" class="input-with-select" placeholder="请输入验证码" v-model="forget.smsCode">
                    <Button :disabled="timeout>0" @click="getTelCode" slot="append">
                      {{timeout===0?'获取验证码':`${timeout}后重试`}}
                    </Button>
                  </Input>
                </FormItem>
                <FormItem style="width: 300px">
                  <Input :key="14" placeholder="请输入密码" type="password" v-model="forget.newPwd"/>
                </FormItem>
                <FormItem style="width: 300px">
                  <Input :key="15" placeholder="请再次输入密码" type="password" v-model="forget.pwdconfig"/>
                </FormItem>
                <FormItem style="width: 300px">
                  <Button @click="submitForgetForm" style="width: 100%" type="primary">确定</Button>
                </FormItem>
                <div class="calign"
                     style="width: 300px;box-sizing: border-box;margin-left: 26px;position: relative;bottom: 10px">
                  <a @click="gotoLog" class="text-info">返回登录</a>
                </div>
              </template>
            </div>
            <div class="flex-column" style="height:250px;margin-bottom:20px;width: 100%" v-show="tabIndex === 1">
              <div class="qr-code flex-column" style="margin-bottom:20px">
                <img :src="qrcodeData" alt="" class="w-full h-full" v-if="qrcodeData && status === 1">
                <img :src="userLogo" alt="" style="width: 60px;height: 60px" v-if="userLogo && status === 2">
              </div>
              <div>微信扫一扫登录</div>
            </div>
            <div class="" style="height:250px;margin-bottom:20px;width: 100%" v-show="tabIndex === 2">
              <div class="flex a-center j-center" style="width: 250px">
                <div class="" id="weixinLogin" style="width: 200px;height: 200px">
                </div>
              </div>
            </div>
          </Form>
          <div class="choose-title-style flex-row" v-if="choosecompany">
            <div class="fz-12 color-33">选择企业</div>
          </div>
          <Form :label-width="40" :model="join" ref="join" style="margin-top: 20px; margin-bottom: 20px;width:100%"
                v-if="choosecompany">
            <div style="height:250px">
              <FormItem style="width: 300px;margin-top: 32px">
                <Select style="width:260px" v-model="join.selectEntId">
                  <Option :key="item.entId" :value="item.entId" v-for="item in joincompanyList">{{ item.entName }}
                  </Option>
                </Select>
              </FormItem>
              <FormItem style="width: 300px;margin-top: 139px">
                <Button @click="joincom"
                        style="width: 100%;margin-right: 10px;background-color:#E6F1FC;color:#2D8CF0 "
                        type="primary">进入公司
                </Button>
              </FormItem>
              <div class="calign"
                   style="width: 300px;box-sizing: border-box;margin-left: 20px;position: relative;bottom: 10px;margin-top: 40px">
                <a @click="gotoBackLog" class="text-info">返回登录</a>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>

    <Modal :closable="false" :mask-closable="false"
           class="modals"
           class-name="vertical-center-modal"
           footer-hide
           v-model="showAboutUs"
           width="920">
      <about-us-widget @cancel="showAboutUs=false" @config="showAboutUs=false"></about-us-widget>
    </Modal>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import AboutUsWidget from '../component/AboutUsWidget'
import {getEntInfoByUrl} from '../../../services/companyapi'
import {setLoginAppInfo} from '../../../utils/util'
import {loadJs} from '../../../utils/loadJs'

export default {
  name: 'Login',
  components: {AboutUsWidget},
  data () {
    return {
      checked: true,
      tabIndex: 2,
      state: 'login',
      timeout: 0,
      headLogins: [{belogin: '手机登录'}, {belogin: '扫码登录'}],
      accountName: '',
      login: {
        telcode: '',
        password: ''
      },
      forgetphone: '',
      forget: {
        smsCode: '',
        newPwd: '',
        pwdconfig: ''
      },
      rules: {
        name: [
          {required: true, message: '输入用户名', trigger: 'blur'},
          {min: 1, max: 15, message: '用户名长度错误', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '输入密码', trigger: 'blur'},
          {min: 1, max: 45, message: '密码长度错误', trigger: 'blur'}
        ]
      },
      choosecompany: false,
      join: {
        selectEntId: 0
      },
      joincompanyList: [],
      qrcodeData: '',
      session: '',
      intervalTime: null,
      status: 0,
      userLogo: '',
      showAboutUs: false,
      entId: 0,
      apptitle: '',
      wxObj: null,
      wxstatus: ''
    }
  },
  watch: {
    accountName (newValue, oldValue) {
      if (newValue.length > oldValue.length) {
        if (newValue.replace(/-/g, '').length < 3) {
          this.accountName = newValue.replace(/-/g, '')
        } else if (newValue.replace(/-/g, '').length >= 3 && newValue.replace(/-/g, '').length < 7) {
          this.accountName = newValue.replace(/-/g, '').replace(/(\d{3})/, '$1-')
        } else if (newValue.replace(/-/g, '').length >= 7) {
          this.accountName = newValue.replace(/-/g, '').replace(/(\d{3})(\d{4})/, '$1-$2-')
        }
      } else {
        this.accountName = this.accountName.trim()
      }
    },
    forgetphone (newValue, oldValue) {
      if (newValue.length > oldValue.length) {
        if (newValue.replace(/-/g, '').length < 3) {
          this.forgetphone = newValue.replace(/-/g, '')
        } else if (newValue.replace(/-/g, '').length >= 3 && newValue.replace(/-/g, '').length < 7) {
          this.forgetphone = newValue.replace(/-/g, '').replace(/(\d{3})/, '$1-')
        } else if (newValue.replace(/-/g, '').length >= 7) {
          this.forgetphone = newValue.replace(/-/g, '').replace(/(\d{3})(\d{4})/, '$1-$2-')
        }
      } else {
        this.forgetphone = this.forgetphone.trim()
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    let path = to.query.redirect
    if (path && path.startsWith('/ldh/ent/')) {
      let url = path.replace('/ldh/ent/', '')
      if (url) {
        try {
          let res = await getEntInfoByUrl(url)
          if (res.code === 0) {
            let app = res.data.app
            let obj = {
              appKey: app.appKey,
              pathEnt: path,
              entId: res.data.id || 0,
              apptitle: app.name || ' '
            }
            setLoginAppInfo(obj)
            next(vm => {
              vm.apptitle = app.name || ' '
              vm.appKey = app.appKey
              vm.entId = res.data.id || 0
              vm.appId = app.id + ''
              vm.pathEnt = path
            })
          } else {
            next()
          }
        } catch (e) {
          next()
        }
      } else {
        setLoginAppInfo('')
        next()
      }
    } else {
      setLoginAppInfo('')
      next()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      let domainName = encodeURI(location.protocol + '//' + location.host)
      loadJs('https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js').then(() => {
        this.wxstatus = domainName || ''
        this.wxObj = new WxLogin({
          self_redirect: false,
          id: 'weixinLogin',
          appid: 'wxc43e2f5ff7fe1f79',
          scope: 'snsapi_login',
          redirect_uri: 'https://www.cfc99.com/personcenter',
          state: this.wxstatus,
          style: 'black',
          href: 'https://image-p.laodao.so/css/qrcode.css'
        })
      })
      let path = this.$route.query.redirect
      if (!this.choosecompany && (path && path.startsWith('/ldh/ent/'))) {
        await this.getQrCodeInfo()
      }
    },
    gotoBackLog () {
      this.choosecompany = false
      this.state = 'login'
    },
    gotoLog () {
      this.state = 'login'
    },
    getTelCode () {
      let phone = this.forgetphone.replace(/-/g, '')
      if (phone.length < 1) {
        this.$Message.info('请输入手机号码')
        return
      }
      this.getForgetSmsReg(phone).then(res => {
        if (res.code === 0) {
          // this.forget.smsCode = res.data.code
          let seconds = 60
          let self = this
          self.time = setInterval(() => {
            --seconds
            self.timeout = seconds
            if (seconds <= 0) {
              clearInterval(self.time)
            }
          }, 1000)
        } else {
          this.$Message.info(res.msg)
        }
      })
    },
    gotoReg () {
      this.$router.replace('/reg')
    },
    gotojoincom () {
      this.$router.replace({
        path: '/reg',
        query: {
          isjoin: 1
        }
      })
    },
    joincom () {
      if (!this.join.selectEntId) {
        return this.$Message.info('请选择要加入的企业')
      }
      let userName = this.accountName.replace(/-/g, '')
      let password = this.login.password
      let entId = this.join.selectEntId
      this.handleLogin({userName, password, entId}).then(() => {
        this.getUserInfo().then(() => {
          if (this.$route.query.redirect) {
            this.$router.replace(this.$route.query.redirect)
          } else {
            this.$router.replace('/')
          }
          // this.choosecompany = false
        })
      }, error => {
        this.$Message.info(error)
      })
    },
    submitForm () {
      let userName = this.accountName.replace(/-/g, '')
      if (!userName) {
        return this.$Message.info('输入用户名')
      }
      if (userName.length < 1 || userName.length > 15) {
        return this.$Message.info('用户名长度错误')
      }
      let password = this.login.password
      if (!password) {
        return this.$Message.info('输入密码')
      }
      if (password.length < 1 || password.length > 15) {
        return this.$Message.info('密码长度错误')
      }
      // let params = {
      //   phone: userName,
      //   pwd: password
      // }
      // this.getLoginInfobyPhone(params).then(res => {
      //   if (res.code === 0) {
      //     if (res.data.entId) {
      //       let entId = res.data.entId
      let entId = ''
      this.handleLogin({userName, password, entId}).then(() => {
        this.getUserInfo().then(() => {
          if (this.$route.query.redirect) {
            this.$router.replace(this.$route.query.redirect)
          } else {
            this.$router.replace('/')
          }
        })
      }, error => {
        this.$Message.info(error)
      })
      //     } else {
      //       if (res.data.entCount > 1) {
      //         let paramses = {
      //           pageNum: 1,
      //           pageSize: 10,
      //           phone: userName,
      //           pwd: password
      //         }
      //         this.getentlistbyphone(paramses).then(res => {
      //           if (res.code === 0) {
      //             this.joincompanyList = res.data.list
      //             this.choosecompany = true
      //           } else {
      //             this.$Message.info(res.msg)
      //           }
      //         })
      //
      //       } else if (res.data.entCount === 1) {
      //         let entId = 0
      //         this.handleLogin({userName, password, entId}).then(() => {
      //           this.getUserInfo().then(() => {
      //             if (this.$route.query.redirect) {
      //               this.$router.replace(this.$route.query.redirect)
      //             } else {
      //               this.$router.replace('/')
      //             }
      //           })
      //         }, error => {
      //           this.$Message.info(error)
      //         })
      //       } else {
      //         this.$Message.info('您未注册企业或加入企业审核中，请确认')
      //       }
      //     }
      //   } else {
      //     this.$Message.info(res.msg)
      //   }
      // })
    },
    submitForgetForm () {
      let forgetphone = this.forgetphone.replace(/-/g, '')
      if (!forgetphone) {
        return this.$Message.info('请输入认证手机')
      }
      if (!this.forget.smsCode) {
        return this.$Message.info('请输入验证码')
      }
      if (!this.forget.newPwd) {
        return this.$Message.info('请输入密码')
      }
      if (this.forget.newPwd !== this.forget.pwdconfig) {
        return this.$Message.info('2次输入密码不一致')
      }
      let params = {
        phone: forgetphone,
        smsCode: this.forget.smsCode,
        newPwd: this.forget.newPwd
      }
      this.putUserPasswdForget(params).then(res => {
        if (res.code === 0) {
          this.accountName = forgetphone
          this.state = 'login'
        } else {
          this.$Message.info(res.msg)
        }
      })
    },
    getQrCodeInfo: async function () {
      let params = {}
      let result = await this.getLoginQrCode(params)
      if (result.code === 0) {
        let data1 = result.data
        this.qrcodeData = 'data:image/png;base64,' + data1.qrcodeData
        this.session = data1.session
        this.tabIndex = 1
        this.intervalTime = setInterval(() => {
          if (this.session) {
            this.getLoginQrCodeStatus(this.session).then(res => {
              if (res.code === 0) {
                let status = parseInt(res.data.status || 0)
                this.status = status
                if (status === 2) {
                  this.userLogo = res.data.userLogo || ''
                } else if (status === 3) {
                  let token = res.data.token
                  if (token) {
                    this.setLoginToken(token)
                    this.getUserInfo().then(() => {
                      this.$router.replace('/')
                    })
                  }
                  if (this.intervalTime) {
                    clearInterval(this.intervalTime)
                    this.intervalTime = null
                    this.status = 0
                  }
                }
              } else if (res.code === 102587) {
                if (this.intervalTime) {
                  clearInterval(this.intervalTime)
                  this.intervalTime = null
                  this.status = 0
                }
                this.getQrCodeInfo()
              }
            }, error => {
              if (this.intervalTime) {
                clearInterval(this.intervalTime)
                this.intervalTime = null
                this.status = 0
              }
            })
          } else {
            if (this.intervalTime) {
              clearInterval(this.intervalTime)
              this.intervalTime = null
              this.status = 0
            }
          }
        }, 2000)
      }
    },
    async onScanClick () {
      this.tabIndex = 2
      // if (this.tabIndex !== 1) {
      //   await this.getQrCodeInfo()
      // }
    },
    onScanCancelClick () {
      if (this.tabIndex === 1) {
        if (this.intervalTime) {
          clearInterval(this.intervalTime)
          this.intervalTime = null
        }
        this.tabIndex = 0
      } else if (this.tabIndex === 2) {
        this.tabIndex = 0
      }
    },
    getLoginTelCodes () {
      let phone = this.accountName.replace(/-/g, '')
      if (phone.length < 1) {
        this.$Message.info('请输入手机号码')
        return
      }
      let params = {
        phone: phone,
      }
      this.getLoginSms(params).then((res) => {
        if (res.code === 0) {
          if (res.data && res.data.code) {
            this.login.password = res.data.code
          }
          let seconds = 60
          let self = this
          self.time = setInterval(() => {
            --seconds
            self.timeout = seconds
            if (seconds <= 0) {
              clearInterval(self.time)
            }
          }, 1000)
        } else {
          this.$Message.info(res.msg)
        }
      })
    },
    /**
     * 短信登录
     * */
    submitSmsForm () {
      let userName = this.accountName.replace(/-/g, '')
      if (!userName) {
        return this.$Message.info('输入手机号码')
      }
      let password = this.login.password
      if (!password) {
        return this.$Message.info('输入短信验证码')
      }
      let params = {
        phone: userName,
        verifyCode: password,
        entId: this.entId || 0
      }
      this.smsLogin(params).then(
        () => {
          this.getUserInfo().then(() => {
            this.$router.replace({
              path: '/personcenter',
              query: {
                type: 1
              }
            })
          })
        },
        (error) => {
          this.$Message.info(error)
          this.$store.dispatch('handleLogOut')
        })
    },
    onContentMy () {
      this.showAboutUs = true
    },
    ...mapActions([
      'handleLogin',
      'handleReg',
      'getUserInfo',
      'getForgetSmsReg',
      'putUserPasswdForget',
      'getLoginInfobyPhone',
      'getentlistbyphone',
      'getLoginQrCode',
      'getLoginQrCodeStatus',
      'setLoginToken',
      'getLoginSms',
      'smsLogin'
    ])
  }
}
</script>

<style lang="scss" scoped>
  #login-content {
    .wrap {
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: url("../../../assets/login/login-bg.png");
      background-position: center center;
      overflow: hidden;

      .bg-container {
        // width 1280px
        /*margin: 10% auto;*/
        position: absolute;
        top: 15%;
        left: 12%;
        height: 500px;
        box-sizing: border-box;

        /*.logoimg {*/
        /*display: block;*/
        /*width: 750px;*/
        /*height: 180px;*/
        /*position: absolute;*/
        /*top: 40%;*/
        /*right: 40%;*/
        /*background-image: url("../../../assets/login/logo-title.png");*/
        /*background-size: contain;*/
        /*background-repeat: no-repeat;*/
        /*}*/
      }
    }
  }

  .full-screen {
    height: 100%;
    overflow: hidden;
  }

  .login-main {
    position: absolute;
    top: 50%;
    left: 65%;
    overflow: hidden;
    transform: translateY(-50%);

    .login-warp {
      position: relative;
      width: 340px;
      top: 30%;
      height: 380px;
      background: white;
      border-radius: 4px;
      float: right;
      z-index: 100;

      .choose-title-style {
        width: 100%;
        height: 49px;
        margin-bottom: 10px;
        background-color: #F5F5F5;
      }

      .login-head {
        list-style: none;
        width: 100%;
        height: 49px;
        margin-bottom: 10px;

        li {
          float: left;
          width: 50%;
          text-align: center;
          height: 49px;
          background-color: #f5f5f5;
          line-height: 49px;
          margin-bottom: 20px;
          border-radius: 4px;
          cursor: pointer;
        }

        .active {
          background: #fff;
          color: blue;
        }
      }
    }

    .login-tip {
      li {
        line-height: 26px;
        font-size: 14px;
        text-align: center;
      }
    }

    .qr-code {
      /*border: 1px solid #ccc;*/
      width: 200px;
      height: 200px;
      margin: auto;
      text-align: center;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .calign {
    text-align: center !important
  }

  .font-title-style {
    font-weight: 900;
    color: white;
    letter-spacing: 2px;
    font-size: 80px;
  }
</style>
<style scoped>
  .modals >>> .ivu-modal-body {
    padding: 0;
  }

  /*.modals >>> .ivu-modal-content {*/
  /*border-bottom-left-radius: 0px;*/
  /*border-bottom-right-radius: 0px;*/
  /*}*/
</style>
